import React from 'react';

type ImgProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

interface ImageProps extends ImgProps {}

export const Image = (props: ImageProps) => (
  <img
    // @ts-ignore
    loading="lazy"
    {...props}
  />
);
